export default __webpack_public_path__ + "img/4d58494fc55313a865994c4b01277fed.jpg";